import { render } from "./SidenavCollapse.vue?vue&type=template&id=eca669ae&scoped=true"
import script from "./SidenavCollapse.vue?vue&type=script&lang=js"
export * from "./SidenavCollapse.vue?vue&type=script&lang=js"

import "./SidenavCollapse.vue?vue&type=style&index=0&id=eca669ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eca669ae"]])

export default __exports__